import Vue from "vue";
import Vuex from "vuex";

// create local data
import createPersistedState from "vuex-persistedstate";

// modules
import auth from "./modules/auth";
import links from "./modules/links";
import data from "./modules/data";
import shopcart from "./modules/shopcart";
import search from "./modules/search";
import favourite from "./modules/favourite";
import axios from "./modules/axios";
import productuniquetypes from "./modules/productuniquetypes";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth,
        links,
        data,
        shopcart,
        search,
        favourite,
        axios,
        productuniquetypes
    },

    plugins: [createPersistedState()]
});

export default store;
